var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "282.000000pt",
    height: "224.000000pt",
    viewBox: "0 0 282.000000 224.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,224.000000) scale(0.100000,-0.100000)",
    fill: "red",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2000 l0 -240 1410 0 1410 0 0 240 0 240 -1410 0 -1410 0 0 -240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1135 l0 -235 1410 0 1410 0 0 235 0 235 -1410 0 -1410 0 0 -235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 240 l0 -240 1410 0 1410 0 0 240 0 240 -1410 0 -1410 0 0 -240z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.c8bd242f93c23d124fb7f3e414768734.svg";
export { ForwardRef as ReactComponent };